/**
 * Production-safe logger utility.
 * Logs are suppressed in production builds.
 */

const isDev = process.env.NODE_ENV !== 'production';

const logger = {
  debug: (...args) => {
    if (isDev) console.log('[DEBUG]', ...args);
  },
  info: (...args) => {
    if (isDev) console.info('[INFO]', ...args);
  },
  warn: (...args) => {
    if (isDev) console.warn('[WARN]', ...args);
  },
  error: (...args) => {
    // Always log errors, even in production
    console.error('[ERROR]', ...args);
  },
};

export default logger;
